import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledContainer = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

const StyledPackageInfo = styled(FlexRow)`
    margin-right: 16px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[250])}
`;

const StyledPackageName = styled.span`
    padding: 0 5px;
    font-weight: 700;
`;

export const StyledButtonsContainer = styled(FlexRow)`
    align-items: center;
`;

const BannerTrialText = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
`;

const DaysLeft = styled.p`
    margin: 0;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[300])};
    font-size: 14px;
`;

export const ButtonText = styled.p`
    margin: 0;
    ${setFontVariant("button", colorsPalettes.indigo[400])}
`;

const StyledIcon = styled(SWReactIcons)`
    margin-right: 8px;
`;

export const StyledButton = styled(IconButton)`
    margin-right: 16px;

    .SWReactIcons svg path {
        fill: ${colorsPalettes.indigo[400]};
    }

    &:hover,
    &:focus,
    &:active {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.indigo[400]} !important;
        }
    }
`;
